/**
 * Central configuration for the game.
 * Keep all magic numbers here so design tweaks are one-stop edits.
 */

export const TILE_SIZE = 64;

// Visible viewport in tiles (portrait). Imported by the debug scene to draw
// the in-game window overlay; will drive the camera in step 3.
export const VIEWPORT_TILES_W = 9;
export const VIEWPORT_TILES_H = 13;

// Total playfield in tiles (larger than viewport so scroll has somewhere to drift)
export const PLAYFIELD_TILES_W = 24;
export const PLAYFIELD_TILES_H = 32;

// Derived pixel dimensions
export const VIEWPORT_PX_W = VIEWPORT_TILES_W * TILE_SIZE;
export const VIEWPORT_PX_H = VIEWPORT_TILES_H * TILE_SIZE;

// Palette (placeholders until pixel art arrives)
export const COLORS = {
  bg: 0x0d0d10,
  ground: 0x2a3e1f,
  foliage: 0x143010,
  water: 0x1c4a7a,
  chimp: 0xc78a3a,
  coconut: 0x6b3d20,
  spider: 0x1a1a1a,
  edge: 0x441818,
} as const;
